import AppImage from '@/components/ui/AppImage';

const CompanyIntroSection = () => {
  return (
    <section className="py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div className="reveal">
            <h1 className="text-5xl md:text-6xl font-bold font-montserrat text-foreground mb-6 leading-tight">
              About <span className="text-primary">Containers by Take A Zip</span>
            </h1>
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed">
              <p>
                At Containers by Take A Zip, we design and deliver high-quality, turn-key container structures built for business and modern lifestyles.
              </p>
              <p>
                Our mission is to help entrepreneurs launch faster, build smarter, and stand out anywhere. We believe that starting a business shouldn't be complicated or time-consuming.
              </p>
              <p>
                With years of experience in container construction and customization, we've perfected the art of creating fully-equipped, business-ready spaces that can be deployed anywhere in the United States.
              </p>
              <p className="font-semibold text-foreground">
                From concept to delivery, we handle everything so you can focus on what matters most—running your business.
              </p>
            </div>
          </div>

          {/* Right Image */}
          <div className="reveal">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <AppImage
                src="https://img.rocket.new/generatedImages/rocket_gen_img_15ccd1699-1770778617240.png"
                alt="Team of workers assembling custom container with modern equipment in workshop"
                className="w-full h-[600px] object-cover" />
              
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default CompanyIntroSection;